var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    staticClass: "grey lighten-4",
    staticStyle: {
      "width": "100%",
      "border-radius": "8px!important"
    },
    attrs: {
      "borderless": "",
      "active-class": "white elevation-4",
      "color": "primary"
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.query.state,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "state", $$v);
      },
      expression: "query.state"
    }
  }, [_vm._l(_vm.states, function (_ref) {
    var text = _ref.text,
        value = _ref.value;
    return [_c('v-btn', _vm._b({
      key: text,
      staticStyle: {
        "border-radius": "8px!important"
      },
      attrs: {
        "width": "calc(100% / ".concat(_vm.states.length, ")")
      }
    }, 'v-btn', {
      value: value
    }, false), [_vm.detect === 'pc' ? [_c('span', [_vm._v(" " + _vm._s(text) + " ")])] : [_c('span', {
      staticStyle: {
        "white-space": "pre-line",
        "line-height": "1.2!important"
      }
    }, [_vm._v(" " + _vm._s("".concat(text.slice(0, 2), "\n").concat(text.slice(2))) + " ")])]], 2)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }